export enum AgreementRoutes {
    Agreement = 'details/:id',
    AgreementList = 'list',
    CreateNewAgreement = 'create-new-agreement',
    InventoryList = 'inventory-list'
}

export enum AgreementsRouteId {
    AgreementId = 'id'
}
